<template>
  <nav class="breadcrumb" aria-label="breadcrumbs">
    <ul v-if="ndc.broader">
      <li v-if="ndc.broader">
        <router-link :to="{ path: ndc.broader.id }">
          ← {{notation(ndc.broader.id)}} {{ndc.broader.label}}
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
import { notation } from '../utils';

export default {
  name: 'Breadcrumb',
  props: [
    'ndc',
  ],
  data() {
    return {
    };
  },
  methods: {
    notation,
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb.vue